export default "__VITE_ASSET__RnAGThN4__"